import React, { Fragment, Component } from "react";
import styles from "./Tutoriel.scss";
import success from "./Success.scss";
import MaterialIcon from "material-icons-react";
import Button from "material-ui/Button";

class Tutoriel extends Component {
  constructor() {
    super();
    this.state = {
      showStep1: true,
      showStep2: false,
      showStep3: false,
      showStep4: false,
      date: "",
    };
  }

  componentDidMount = () => {
    var now = new Date();
    console.log(now.getFullYear());
    console.log(now.getMonth() + 1);
    if (now.getMonth() + 1 >= 10) {
      this.setState({
        date: `${now.getFullYear()}-${now.getMonth() + 1}`,
      });
    } else {
      this.setState({
        date: `${now.getFullYear()}-0${now.getMonth() + 1}`,
      });
    }
  };

  Page = (step) => {
    var page = 0;
    page = step + 1;
    console.log("Page nb ", page);
    if (page === 1) {
      this.setState({
        showStep1: true,
        showStep2: false,
        showStep3: false,
        showStep4: false,
      });
      console.log("Step 1 ", page);
    } else if (page === 2) {
      this.setState({
        showStep1: false,
        showStep2: true,
        showStep3: false,
        showStep4: false,
      });
      console.log("Step 2 ", page);
    } else if (page === 3) {
      this.setState({
        showStep1: false,
        showStep2: false,
        showStep3: true,
        showStep4: false,
      });
      console.log("Step 3 ", page);
    } else {
      var link = "https://app.digidocteur.com/";
      this.setState({
        showStep1: false,
        showStep2: false,
        showStep3: false,
        showStep4: true,
      });
      setTimeout(() => {
        window.location.replace(link);
      }, 3500);
      console.log("Step 4 ", page);
    }
  };

  render() {
    return (
      <div>
        {this.state.showStep1 &&
          !this.state.showStep2 &&
          !this.state.showStep3 &&
          !this.state.showStep4 && (
            <div className={styles.outerContainer}>
              <div className={styles.container}>
                <div className={styles.header}>
                  <div className={styles.headerLeftBlock}>
                    <h3>Configurons ensemble votre TV</h3>
                    <p>
                      Digidocteur diffuse les vidéos médicales depuis
                      l'ordinateur de votre cabinet vers votre TV en salle
                      d'attente <b>en WiFi</b>, de façon totalement transparente
                    </p>
                  </div>
                  <div className={styles.headerRightBlock}>
                    <MaterialIcon
                      className={styles.floatingIcon}
                      color="#2196F3"
                      icon="cast"
                      size={75}
                    />
                  </div>
                </div>
                <div className={styles.body}>
                  <ul>
                    <li>
                      Si vous avez une "Smart TV" récente, compatible avec le
                      protocole de diffusion à distance Chromecast, vous pouvez
                      passer à l'étape suivante.
                    </li>
                    <li>
                      Si vous avez une TV plus ancienne et vous avez déjà une
                      clé USB Chromecast branchée dessus, passez également à
                      l'étape suivante.
                    </li>
                    <li>
                      Si vous n'avez pas de Smart TV ni de Chromecast, vous
                      pouvez acquérir une clé Chromecast dans la{" "}
                      <a
                        target="_blank"
                        href="https://store.google.com/fr/product/chromecast"
                      >
                        boutique officielle Google
                      </a>
                      .
                    </li>
                    <li>
                      Si vous souhaitez des conseils pour une installation de
                      TV, envoyez un mail à l'adresse suivante
                      contact@digidocteur.com ou téléphonez au
                      <a
                        href={`https://calendly.com/digidocteur/15min?primary_color=2196f3&month=${this.state.date}&back=1`}
                        target="_blank"
                      >
                        06 51 52 66 22
                      </a>
                      .
                    </li>
                    <li>
                      Les vidéos sont disponibles sur une application mobile
                      pour vos patients. Si vous ne souhaitez pas de TV, un
                      poster avec un QR code est suffisant. Contactez nous par
                      mail pour son envoi : contact@digidocteur.com
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.buttonsContainer}>
                <Button
                  variant="raised"
                  color="primary"
                  className={styles.prevButton}
                  onClick={() => {
                    this.Page(1);
                  }}
                >
                  Étape suivante
                </Button>
              </div>
            </div>
          )}
        {!this.state.showStep1 &&
          this.state.showStep2 &&
          !this.state.showStep3 &&
          !this.state.showStep4 && (
            <div className={styles.outerContainer}>
              <div className={styles.container}>
                <div className={styles.header}>
                  <div className={styles.headerLeftBlock}>
                    <h3>Votre TV est prête ?</h3>
                    <p>
                      Passons à l'installation de l'application <b>Digicast</b>{" "}
                      qui permet de diffuser les vidéos médicales sur votre TV.
                    </p>
                  </div>
                  <div className={styles.headerRightBlock}>
                    <MaterialIcon
                      className={styles.floatingIcon}
                      color="#2196F3"
                      icon="cast"
                      size={75}
                    />
                  </div>
                </div>
                <div className={styles.body}>
                  <ul>
                    <li>
                      L'ordinateur sur lequel Digicast est installé doit rester
                      allumé pour pouvoir diffuser les vidéos sur votre TV.
                    </li>
                    <li>
                      Si vous avez une assistante médicale, nous vous
                      conseillons d'installer Digicast sur son ordinateur, qui
                      reste normalement allumé toute la journée.
                    </li>
                    <li>
                      <a href="https://digidocteur.s3.eu-central-1.amazonaws.com/digicast/digidocteur-win-1.1.4s.exe">
                        Cliquez ici pour télécharger Digicast pour Windows
                      </a>
                      . &nbsp;
                      <MaterialIcon
                        className={styles.floatingIcon}
                        color="#2196F3"
                        icon="desktop_windows"
                        size={25}
                      />
                    </li>
                    <li>
                      <a href="https://digidocteur.s3.eu-central-1.amazonaws.com/digicast/digidocteur-mac-1.1.4.dmg">
                        Cliquez ici pour télécharger Digicast pour Mac
                      </a>
                      . &nbsp;
                      <MaterialIcon
                        className={styles.floatingIcon}
                        color="#2196F3"
                        icon="desktop_mac"
                        size={25}
                      />
                    </li>
                    <li>
                      Si vous souhaitez de l'assistance pour Digicast,
                      <a
                        href={`https://calendly.com/digidocteur/15min?primary_color=2196f3&month=${this.state.date}&back=1`}
                        target="_blank"
                      >
                        {" "}
                        cliquez ici
                      </a>
                      .
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.buttonsContainer}>
                <Button
                  variant="raised"
                  color="primary"
                  className={styles.prevButton}
                  onClick={() => {
                    this.Page(2);
                  }}
                >
                  Étape suivante
                </Button>
                <Button
                  variant="flat"
                  color="secondary"
                  className={styles.nextButton}
                  onClick={() => {
                    this.Page(0);
                  }}
                >
                  Retour
                </Button>
              </div>
            </div>
          )}
        {!this.state.showStep1 &&
          !this.state.showStep2 &&
          this.state.showStep3 &&
          !this.state.showStep4 && (
            <div className={styles.outerContainer}>
              <div className={styles.container}>
                <div className={styles.header}>
                  <div className={styles.headerLeftBlock}>
                    <h3>Installons Digicast</h3>
                    <p>
                      Si vous avez bien téléchargé Digicast sur votre la machine
                      qui servira à la diffusion des vidéos, nous pouvons
                      procéder.
                    </p>
                  </div>
                  <div className={styles.headerRightBlock}>
                    <MaterialIcon
                      className={styles.floatingIcon}
                      color="#2196F3"
                      icon="cast"
                      size={75}
                    />
                  </div>
                </div>
                <div className={styles.body}>
                  <ul>
                    <li>
                      Cliquez sur l'installeur téléchargé. Digicast s'installe.
                    </li>
                    <li>
                      Si votre pare-feu vous bloque, autorisez les droits
                      d'accès au réseau.
                    </li>
                    <li>
                      Connectez-vous avec votre identifiant et votre mot de
                      passe Digidocteur.
                    </li>
                    <li>
                      Choisissez une Chromecast ou une Smart TV sur votre réseau
                      et démarrez la diffusion.
                    </li>
                    <li>
                      Vous pouvez modifier les vidéos diffusées depuis cette
                      interface en ligne.
                    </li>
                    <li>
                      Si vous souhaitez de l'assistance pour Digicast,
                      <a
                        href={`https://calendly.com/digidocteur/15min?primary_color=2196f3&month=${this.state.date}&back=1`}
                        target="_blank"
                      >
                        {" "}
                        cliquez ici
                      </a>
                      .
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.buttonsContainer}>
                <Button
                  variant="raised"
                  color="primary"
                  className={styles.prevButton}
                  onClick={() => {
                    this.Page(3);
                  }}
                >
                  Tout fonctionne !
                </Button>
                <Button
                  variant="flat"
                  color="secondary"
                  className={styles.nextButton}
                  onClick={() => {
                    this.Page(1);
                  }}
                >
                  Retour
                </Button>
              </div>
            </div>
          )}
        {!this.state.showStep1 &&
          !this.state.showStep2 &&
          !this.state.showStep3 &&
          this.state.showStep4 && (
            <div className={success.containerSuccess}>
              <h1 className={success.title}>
                Tutoriel terminé, <br></br>Vous allez être redirigé...
              </h1>
              <div className={success.checkmark}>
                <svg
                  className={success.checkmark__check}
                  height="36"
                  viewBox="0 0 48 36"
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M47.248 3.9L43.906.667a2.428 2.428 0 0 0-3.344 0l-23.63 23.09-9.554-9.338a2.432 2.432 0 0 0-3.345 0L.692 17.654a2.236 2.236 0 0 0 .002 3.233l14.567 14.175c.926.894 2.42.894 3.342.01L47.248 7.128c.922-.89.922-2.34 0-3.23"></path>
                </svg>
                <svg
                  className={success.checkmark__background}
                  height="115"
                  viewBox="0 0 120 115"
                  width="120"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M107.332 72.938c-1.798 5.557 4.564 15.334 1.21 19.96-3.387 4.674-14.646 1.605-19.298 5.003-4.61 3.368-5.163 15.074-10.695 16.878-5.344 1.743-12.628-7.35-18.545-7.35-5.922 0-13.206 9.088-18.543 7.345-5.538-1.804-6.09-13.515-10.696-16.877-4.657-3.398-15.91-.334-19.297-5.002-3.356-4.627 3.006-14.404 1.208-19.962C10.93 67.576 0 63.442 0 57.5c0-5.943 10.93-10.076 12.668-15.438 1.798-5.557-4.564-15.334-1.21-19.96 3.387-4.674 14.646-1.605 19.298-5.003C35.366 13.73 35.92 2.025 41.45.22c5.344-1.743 12.628 7.35 18.545 7.35 5.922 0 13.206-9.088 18.543-7.345 5.538 1.804 6.09 13.515 10.696 16.877 4.657 3.398 15.91.334 19.297 5.002 3.356 4.627-3.006 14.404-1.208 19.962C109.07 47.424 120 51.562 120 57.5c0 5.943-10.93 10.076-12.668 15.438z"></path>
                </svg>
              </div>
              <a
                className={styles.closeWelcome}
                href="https://app.digidocteur.com/"
              >
                Fermer le guide d'installation
              </a>
            </div>
          )}
      </div>
    );
  }
}

export default Tutoriel;



// WEBPACK FOOTER //
// ./src/pages/tutoriel/Tutoriel.jsx